export const styles = {
    modal: {
        closeOnEsc: false,
        closeOnOverlayClick: false,
        size: "4xl",
    },
    modalContent: {
        w: { base: "95%", md: "900px" },
        bgColor: "white",
        overflowX:"hidden"
    },
    modalHeader: {
        fontWeight: "600",
        fontSize: "24px",
        lineHeight: "24px",
        letterSpacing: 0,
        color: "#1D287AD9",
        borderBottom: "1px solid #00000033",
        py: 2
    },
    modalFooter: {
        borderTop: "1px solid #00000033",
        gap: "16px",
        w: "full",
        justifyContent: "space-between",
        alignItems: "center",
    },
    cancelButton: {
        color: "#7464CE",
        bg: "#FFFFFF",
        border: "1px solid #D9D6ED",
        fontSize: "14px",
        h: "36px",
        borderRadius: "8px",
        cursor: "pointer",
    },
    rightControls: {
        position: "absolute",
        zIndex: 1000,
        bottom: "0px",
        right: "0px",
        spacing: "4px",
    },
    leftControls: {
        position: "absolute",
        zIndex: 1000,
        bottom: "0px",
        left: "0px",
        spacing: "4px",
    },
    rightTopControls: {
        position: "absolute",
        zIndex: 1000,
        right: "0px",
        top: "0px",
        spacing: "4px",
    },
    fileUploadCenter: {
        h: "400px",
        flexDirection: "column",
        bg: "#F5F5F5",
        border: "1px solid #00000029",
        m: "8px 24px"
    },
    fileUploadText: {
        fontWeight: 500,
        fontSize: "18px",
        lineHeight: "27px",
        letterSpacing: "0.1px",
        textAlign: "center",
        color: "#000000BF"
    },
    uploadLimitText: {
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "21px",
        letterSpacing: "0.1px",
        textAlign: "center",
        color: "#00000080"
    },
    imageListThumbnail: (isSelected) => ({
        w: "64px",
        h: "40px",
        cursor: "pointer",
        border: isSelected ? "2px solid #1D287AD9" : "2px solid #F5F5F54D",
    }),
};